import React, { useState } from 'react';
import './despacho.css';

function Despacho() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Username:', username);
    console.log('Password:', password);
   };

  return (
    <div className="container container-mh">
      <div className="titlesecundario">
        <h1>Formulario de Acceso</h1>
        <hr className="hr-gob" />
          <div className="card-noticias">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Nombre de Usuario:</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={handleUsernameChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Contraseña:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={handlePasswordChange}
              />
            </div>
            <button className="btn-doradodespacho" type="submit">
              Iniciar Sesión
            </button>
          </form>
        </div>
     
      </div>
     </div>

     
  );
}

export default Despacho;
